// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_jf-0";